import * as React from 'react';
import * as AlertPrimitive from '@radix-ui/react-alert-dialog';
import { cn } from '@/lib/utils';
import { buttonVariants } from './button';

export const AlertDialog = AlertPrimitive.Root;
export const AlertDialogTrigger = AlertPrimitive.Trigger;

export const AlertDialogContent = React.forwardRef<React.ElementRef<typeof AlertPrimitive.Content>, React.ComponentPropsWithoutRef<typeof AlertPrimitive.Content>>(
  ({ className, ...props }, ref) => (
    <AlertPrimitive.Portal>
      <AlertPrimitive.Overlay className="fixed inset-0 z-50 bg-ink/40 backdrop-blur-[2px]" />
      <AlertPrimitive.Content
        ref={ref}
        className={cn(
          'fixed z-50 flex w-full flex-col gap-4 bg-surface p-5 shadow-[var(--shadow-pop)]',
          'inset-x-0 bottom-0 rounded-t-2xl pb-safe',
          'sm:inset-auto sm:top-1/2 sm:left-1/2 sm:w-[min(28rem,calc(100vw-2rem))] sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-2xl',
          className,
        )}
        {...props}
      />
    </AlertPrimitive.Portal>
  ),
);
AlertDialogContent.displayName = 'AlertDialogContent';

export const AlertDialogTitle = React.forwardRef<React.ElementRef<typeof AlertPrimitive.Title>, React.ComponentPropsWithoutRef<typeof AlertPrimitive.Title>>(
  ({ className, ...props }, ref) => <AlertPrimitive.Title ref={ref} className={cn('text-lg font-semibold', className)} {...props} />,
);
AlertDialogTitle.displayName = 'AlertDialogTitle';

export const AlertDialogDescription = React.forwardRef<React.ElementRef<typeof AlertPrimitive.Description>, React.ComponentPropsWithoutRef<typeof AlertPrimitive.Description>>(
  ({ className, ...props }, ref) => <AlertPrimitive.Description ref={ref} className={cn('text-[15px] text-ink-2', className)} {...props} />,
);
AlertDialogDescription.displayName = 'AlertDialogDescription';

export const AlertDialogAction = React.forwardRef<React.ElementRef<typeof AlertPrimitive.Action>, React.ComponentPropsWithoutRef<typeof AlertPrimitive.Action> & { danger?: boolean }>(
  ({ className, danger, ...props }, ref) => (
    <AlertPrimitive.Action ref={ref} className={cn(buttonVariants({ variant: danger ? 'danger' : 'primary' }), className)} {...props} />
  ),
);
AlertDialogAction.displayName = 'AlertDialogAction';

export const AlertDialogCancel = React.forwardRef<React.ElementRef<typeof AlertPrimitive.Cancel>, React.ComponentPropsWithoutRef<typeof AlertPrimitive.Cancel>>(
  ({ className, ...props }, ref) => <AlertPrimitive.Cancel ref={ref} className={cn(buttonVariants({ variant: 'outline' }), className)} {...props} />,
);
AlertDialogCancel.displayName = 'AlertDialogCancel';
